import { ApiCall } from "../../../helper/axios";
import { getAdminToken } from "../../../helper/adminAuthStorage";

// All admin calls go to the Node backend with the admin token in Authorization.
// Node verifies it and forwards it to WordPress for data fetches.
export const adminApi = (method, path, payload) =>
  ApiCall(method, path, payload, { authorization: getAdminToken() });
